import { Pencil } from 'react-bootstrap-icons';

const PlaceholderVariableItem = ({ variable, index, selectedVariable, handleEditClick, readOnly, translate }) => {
  return (
    <div
      key={index}
      className={`variable-item d-flex flex-column mb-1 px-2 py-1 ${
        selectedVariable?.placeholder === variable.placeholder ? 'bg-primary bg-opacity-10' : ''
      }`}
    >
      <div className="d-flex justify-content-between align-items-center mb-1">
        <p
          className={`${
            selectedVariable?.placeholder === variable.placeholder ? 'text-primary' : 'text-dark'
          } m-0 text-truncate`}
          title={variable.placeholder}
        >
          {`{{${variable.placeholder}}}`}
        </p>
        <button
          disabled={readOnly}
          onClick={() => handleEditClick(variable)}
          className={`btn btn-link btn-sm p-1 ${
            selectedVariable?.placeholder === variable.placeholder ? 'text-primary' : 'text-dark'
          }`}
          title={translate('edit_variable')}
        >
          <Pencil className={readOnly ? 'text-secondary-dark' : ''} size={14} />
        </button>
      </div>
      <div
        className={`small text-truncate rounded px-2 py-1 ${
          selectedVariable?.placeholder === variable.placeholder
            ? 'bg-primary bg-opacity-10'
            : 'bg-light text-muted-foreground'
        }`}
        style={{ maxWidth: '100%', color: 'gray' }}
        title={JSON.stringify(variable.value)}
      >
        {JSON.stringify(variable.value)}
      </div>
    </div>
  );
};

export default PlaceholderVariableItem;
